/**
 * SkipToContent Component (Task 10.5)
 *
 * Provides a skip link for keyboard navigation users to jump to main content
 * Visible only when focused
 */

export function SkipToContent() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleClick}
      className="skip-to-main"
      style={{
        position: 'absolute',
        left: '-9999px',
        zIndex: 999,
        padding: '1rem 1.5rem',
        backgroundColor: 'var(--color-dark-panel)',
        color: 'var(--color-dark-text)',
        textDecoration: 'none',
        borderRadius: 'var(--radius-md)',
        fontWeight: 'var(--font-weight-medium)',
      }}
    >
      Skip to main content
    </a>
  );
}
